<template>
  <a href="#" @click.prevent="routeToListFn" class="link-band-list">{{viewMoreTitle}} 콘텐츠 모두보기</a>
</template>

<script>
export default {
  name: 'ViewMore',
  props: {
    viewMoreTitle: {
      type: String
    },
    routeToListFn: {
      type: Function
    }
  }
}
</script>
